export default "__VITE_ASSET__Dcnpwmmb__"